import { render, staticRenderFns } from "./EProductRouterLink.vue?vue&type=template&id=5642ff48&"
import script from "./EProductRouterLink.vue?vue&type=script&lang=js&"
export * from "./EProductRouterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5642ff48')) {
      api.createRecord('5642ff48', component.options)
    } else {
      api.reload('5642ff48', component.options)
    }
    module.hot.accept("./EProductRouterLink.vue?vue&type=template&id=5642ff48&", function () {
      api.rerender('5642ff48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/EProductRouterLink.vue"
export default component.exports